import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/SaveRounded';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import SaveVideoSettingsTooltip from './SaveVideoSettingsTooltip';
import SaveVideoCircleProgress from './SaveVideoCircleProgress';

const styles = (theme) => ({});

const SaveVideoSettingsButton = (props) => {
    const { presetsLoading, savingPanelOpen, videoSettingsLoading, backgroundVideosLoading, loadingAudioData, audioAnalyzing, save, savingInProgress, showCriticalOperationProgressWarning, videoDirty, audioDirty, lyricExtractionProcessing } = props;
    const isBadgeVisible = !videoSettingsLoading && (videoDirty || audioDirty) && !savingInProgress;
    const [progress, setProgress] = useState(0);

    const isDisabled = [
        presetsLoading,
        savingPanelOpen,
        videoSettingsLoading,
        savingInProgress,
        backgroundVideosLoading,
        loadingAudioData,
        audioAnalyzing,
        lyricExtractionProcessing,
    ].some(Boolean);

    useEffect(() => {
        if (!savingInProgress)
            setProgress(0);
    }, [savingInProgress])

    const onSaveButtonClick = () => {
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        save(true);
    };

    return (
        <SaveVideoSettingsTooltip>
            <div>
                <SaveVideoCircleProgress
                    disabled={isDisabled}
                    loading={savingInProgress}
                    onClick={onSaveButtonClick}
                    aria-label='Save Video'
                    progress={progress}
                    progressSize={40}
                    badge={isBadgeVisible}
                >
                    <SaveIcon />
                </SaveVideoCircleProgress>
            </div>
        </SaveVideoSettingsTooltip>
    );
}

const mapStateToProps = (state) => {
    const {
        backgroundVideosLoading,
        videoSettingsLoading,
        loadingAudioData,
        audioAnalyzing,
        videoDirty,
        audioDirty,
        presetsLoading,
        lyricExtractionProcessing
    } = state.create;

    const { savingInProgress, savingPanelOpen } = state.create.videoSavingState;

    return {
        presetsLoading,
        savingPanelOpen,
        backgroundVideosLoading,
        videoSettingsLoading,
        loadingAudioData,
        audioAnalyzing,
        videoDirty,
        audioDirty,
        savingInProgress,
        lyricExtractionProcessing
    }
}

const mapDispatchToProps = (dispatch) => {
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());
    return { showCriticalOperationProgressWarning }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SaveVideoSettingsButton, styles));